import { capitalize } from '@shared/utils'

import {
  CWCodeSnippet,
  CWCodeSnippetControls,
  CWCodeSnippetControlsCopy,
} from '../ComponentsWeb/CodeSnippet'

import type { SupportedLanguages } from '@circlefin/components/lib/CodeSnippet'

export interface ChatCodeSnippetProps {
  /**
   * The code content to display.
   */
  content: string
  /**
   * The programming language for syntax highlighting.
   */
  language: SupportedLanguages
}

/**
 * A code snippet component for chat/markdown contexts.
 */
export const ChatCodeSnippet = ({
  content,
  language,
}: ChatCodeSnippetProps) => {
  return (
    <CWCodeSnippet
      className="[&_pre]:pt-8"
      content={content}
      language={language}
      expanded
    >
      <CWCodeSnippetControls>
        <div className="flex items-center gap-3">
          <p className="text-neutral type-body-sm-bold">
            {capitalize(language)}
          </p>
          <CWCodeSnippetControlsCopy />
        </div>
      </CWCodeSnippetControls>
    </CWCodeSnippet>
  )
}
